export const dropdownMixin = {
   data: function(){
      return {
         opened: false
      }
   },
   computed: {
      isOpened: function(){
         return this.opened;
      }
   },
   methods: {
      dropToggle: function(){
         this.opened = !this.opened;
      },
      dropClose: function(){
         this.opened = false;
      }
   }
};


// WEBPACK FOOTER //
// ./src/Banet/mixins/dropdownMixin.js